import { render, staticRenderFns } from "./RecipesGroupsDetails.vue?vue&type=template&id=1161e30a"
import script from "./RecipesGroupsDetails.vue?vue&type=script&lang=js"
export * from "./RecipesGroupsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports